<template>
 <div class="app-container">
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="120px" size="mini">
        <div class="formItemBox">
        <el-form-item label="创建时间:" class="item2">
          <el-date-picker
            v-model="repairTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
          <el-form-item label="车辆号牌:">
          <el-input placeholder="可支持多个" type="textarea" v-model="searchFrom.cph" ></el-input>
        </el-form-item>
        <el-form-item label="所属小队:" >
          <el-select v-model="searchFrom.teamCode" filterable placeholder="请选择" clearable  >
            <el-option v-for="item in XDList" :label="item.name" :value="item.code" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        </div>
        <div style="display: flex;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox" style="flex-shrink:0">
            <el-button type="primary" v-if="btnFlg[0]" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary"   size="mini" @click="resetForm('searchFrom')">重置</el-button>
            <el-button type="primary" v-if="btnFlg[1]" @click="exportFn" size="mini" :disabled="isDisable">导出</el-button>
            <el-button type="primary" v-if="btnFlg[2]" @click="addFn" size="mini" >新增</el-button>
            <el-button type="primary" v-if="btnFlg[3]" @click="delFn" size="mini" >删除</el-button>
            <el-button type="primary" v-if="btnFlg[4]" @click="importFn" size="mini" >导入</el-button>
            <el-button type="primary" v-if="btnFlg[5]"  size="mini" @click="modelDown">模板下载</el-button>
          </div>
          <div class="tongjiBox">
            <el-form-item style="margin-left:8px">
                <p class="margin0" >
                  交强险合计<span class="red">{{sum.totalCompulsoryAmount}}</span>元
                </p>
              </el-form-item>
              <el-form-item style="margin-left:8px">
                <p class="margin0" >
                  商业险合计<span class="red">{{sum.totalCommercialAmount }}</span>元
                </p>
              </el-form-item>
              <el-form-item style="margin-left:8px">
                <p class="margin0" >
                  合计金额<span class="red">{{sum.totalTotalAmount }}</span>元
                </p>
              </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList" ref="table" v-loading="loading" bordersize="mini" @selection-change="selectGoods" @row-click="handleRowClick" style="width: 100%" height="100%" center border class="tableComent" :cell-class-name="cellClassName">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column  type="index" width="55" label="序号"></el-table-column>
        <el-table-column label="操作" width="160" >
          <template slot-scope="scope">
            <div>
              <el-button v-if="btnFlg[6]" type="text" size="mini" @click="pingzhengFn(scope.row)">凭证</el-button>
              <el-button v-if="btnFlg[7]" type="text" size="mini" @click="editFn(scope.row)">修改</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="insuranceNo" label="保险单号" min-width="190"></el-table-column>
        <el-table-column prop="plateNumber" label="车牌号" min-width="90"></el-table-column>
        <el-table-column prop="insuranceCompany" label="保险公司" min-width="150"></el-table-column>
        <el-table-column prop="teamOrgName" label="小队" min-width="100"></el-table-column>
        <el-table-column prop="compulsoryAmount" label="交强险金额(元)" width="130"></el-table-column>
        <el-table-column prop="commercialAmount" label="商业险金额(元)" width="130"></el-table-column>
        <el-table-column prop="vehicleTaxAmount" label="车船税金额(元)" width="130"></el-table-column>
        <el-table-column prop="totalAmount" label="合计金额(元)" width="130"></el-table-column>
        <el-table-column prop="insuranceDateFrom" label="保单开始日期" :formatter="dateFormat" width="150" ></el-table-column>
        <el-table-column prop="insuranceDateTo" label="保单结束日期" :formatter="dateFormat" width="150" ></el-table-column>
        <el-table-column prop="insuranceDays" label="保险距离到期天数" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="remark" label="备注" min-width="130"></el-table-column>
        <el-table-column prop="createUser" label="创建人" min-width="130"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" :formatter="dateTimeFormat" width="170"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新增 -->
    <el-dialog :title="isAdd?'新增':'修改'" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog" :visible.sync="addFlag" width="750px" center>
      <div>
        <el-form :inline="true" :rules="rules" ref="addForm" :model="addForm" class="demo-form-inline jiaoyan"  label-width="110px" size="mini" v-if="addFlag">
          <el-form-item label="小队:" prop="teamOrgCode" class="width1" >
            <el-select v-model="addForm.teamOrgCode" filterable placeholder="请选择" clearable @change="xiaoduiChange" >
              <el-option v-for="item in XDList" :label="item.name" :value="item.code" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车牌号:" prop="plateNumber" class="width1" >
            <el-select v-model="addForm.plateNumber" filterable placeholder="请选择" @change="carChange">
              <el-option v-for="item in carList" :label="item.vhcNo" :value="item.vhcNo" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <br>
          <el-form-item label="保险公司" prop="insuranceCompany" class="width1">
            <el-input placeholder="" v-model="addForm.insuranceCompany"></el-input>
          </el-form-item>
          <el-form-item label="交强险金额:" prop="compulsoryAmount" class="jiage" >
            <el-input placeholder="" v-number-input.float="2" maxlength="8" v-model="addForm.compulsoryAmount"></el-input>
            <span class="danwei">元</span>
          </el-form-item>
          <el-form-item label="商业险金额:" prop="commercialAmount" class="jiage" >
            <el-input placeholder="" v-number-input.float="2" maxlength="8" v-model="addForm.commercialAmount"></el-input>
            <span class="danwei">元</span>
          </el-form-item>
          <el-form-item label="车船税金额:" prop="vehicleTaxAmount" class="jiage" >
            <el-input placeholder="" v-number-input.float="2" maxlength="8" v-model="addForm.vehicleTaxAmount"></el-input>
            <span class="danwei">元</span>
          </el-form-item>
           <br>
          <el-form-item label="保单开始日期" prop="insuranceDateFrom" class="jiage" >
            <el-date-picker
              v-model="addForm.insuranceDateFrom"
              format="yyyy-MM-dd"
              value-format="timestamp"
              type="date"
              placeholder="选择日期"
              @change="handleDateChange"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="保单结束日期" prop="insuranceDateTo" class="jiage" >
            <el-date-picker
              v-model="addForm.insuranceDateTo"
              format="yyyy-MM-dd"
              value-format="timestamp"
              type="date"
              placeholder="选择日期"
              @change="handleDateChange"
            ></el-date-picker>
          </el-form-item>
          <br>
          <el-form-item label="凭证:" class="remark" prop="remark" v-if="addFlag" >
             <!-- <uploadImgs :imgList.sync='imgList' :max=3 @remove="remove"></uploadImgs> -->
               <uploadFiles :fileArr.sync='imgList' :max=10 @remove="remove"></uploadFiles>
          </el-form-item>
          <br>
          <el-form-item label="备注:" class="remark" prop="remark" >
            <el-input placeholder="" maxlength="500" v-model="addForm.remark"></el-input>
          </el-form-item>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addFlag = false">取 消</el-button>
        <el-button type="primary" @click="saveFn()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="凭证" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="pzFlag" width="300px" center>
      <div class="fujianBox">
        <el-button type="text" v-for="item in pzList" @click="fujianClick(item)" :key="item.name">{{item.name}}</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看图片" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="lookImgFlag"
      append-to-body width="800px" center>
      <div style="text-align: right;">
        <div id="printMe" ref="print">
          <el-image style="width: 100%;" :src="imgUrl" fit="contain"></el-image>
        </div>
      </div>
    </el-dialog>
    <!-- 导入 -->
    <importC v-if="importDialog" @DRsave="DRsave" @destroy="destroy"></importC>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { formatterRowEmpty, dateTimeFormat, dateFormat, toFixed } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { organizationTree, cVIlists, cVehicleInsuranceNewList, saveOrUpdateWithAttachments, cVehicleInsuranceNewdetail, cVehicleInsuranceNewimport,
  cVehicleInsuranceNewdeletes, cVehicleInsuranceNewListTotal } from '@/api/vgs-driver2.0'
import uploadFiles from '@/views/newTMS/publicFiles/uploadFiles.vue'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import importC from '@/components/import.vue'
export default {
  components: {
    uploadFiles, ElImageViewer, importC
  },
  data () {
    return {
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      formatterRowEmpty: formatterRowEmpty,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      repairTime: [],
      total: 0,
      loading: false,
      isDisable: false,
      sum: {},
      rules: {
        teamOrgCode: [
          { required: true, message: '请选择小队', trigger: 'blur' }
        ],
        plateNumber: [
          { required: true, message: '请选择车辆', trigger: 'blur' }
        ],
        insuranceCompany: [
          { required: true, message: '请输入保险公司', trigger: 'blur' }
        ],
        insuranceDateFrom: [
          { required: true, message: '请选择保单开始日期', trigger: 'blur' }
        ],
        insuranceDateTo: [
          { required: true, message: '请选择保单结束日期', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (this.addForm.insuranceDateFrom && value) {
                if (new Date(value) <= new Date(this.addForm.insuranceDateFrom)) {
                  callback(new Error('保单结束日期必须大于开始日期'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        compulsoryAmount: [
          { required: true, message: '请输入交强险金额', trigger: 'blur' }
        ],
        commercialAmount: [
          { required: true, message: '请输入商业险金额', trigger: 'blur' }
        ],
        vehicleTaxAmount: [
          { required: true, message: '请输入船税金额', trigger: 'blur' }
        ]
      },
      isAdd: false,
      addFlag: false,
      addForm: { deleteAttachmentIds: [] },
      imgList: [],
      XDList: [],
      sijiList: [],
      carList: [],
      pzList: [],
      pzFlag: false,
      lookImgFlag: false,
      lookimgList: [],
      importDialog: false,
      btnFlg: [],
      btnIdArr: ['01N02I0100', '01N02I0200', '01N02I0300', '01N02I0400', '01N02I0500', '01N02I0600', '01N02I0700', '01N02I0800']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr)
    this.searchFn()
    organizationTree({ flag: 1 }).then((res) => {
      if (res[0].orgType == 1) {
        this.XDList = res[0].children
      } else {
        this.XDList = res
      }
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 166) + 'px'
  },
  methods: {
    // 导入
    importFn () {
      this.importDialog = true
    },
    // 导入模板下载
    modelDown () {
      var tempwindow = window.open('_blank') // 先打开页面
      tempwindow.location = 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/tms/excel/车辆保险导入模板.xlsx'// 后更改页面地址
    },
    DRsave (formData) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      // formData.append('params', JSON.stringify({ id: '' }))
      cVehicleInsuranceNewimport(formData).then(res => {
        loading.close()
        this.importDialog = false
        var that = this
        this.msg = this.$message({
          showClose: true,
          message: res.message,
          duration: 3000,
          type: 'success',
          onClose () {

          }
        })
        this.getList(this.searchFrom)
      }).catch(err => {
        if (err.code == -1) {
          this.$message({
            type: 'warning',
            message: err.data ? err.data : err.message,
            onClose () {
              loading.close()
            }
          })
          this.isDisable = false
        } else if (err.code == 1) {
          this.isDisable = false
          this.$confirm('存在异常信息，是否确认导出异常信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const loading = this.$loading({
              lock: true,
              text: '正在导出异常信息...'
            })
            let form = { }
            exportExcel(
              this.global.driverNameT + '/cVehicleInsuranceNew/exportError',
              form,
              '异常信息表'
            )
            setTimeout(() => {
              this.$message({
                type: 'success',
                message: err.data ? err.data : err.message
              })
              loading.close()
              this.daoRuMark = false
              this.importDialog = false
              this.getList(this.searchFrom)
            }, 3000)
          }).catch(() => {
            this.daoRuMark = false
            this.$message({
              type: 'warning',
              message: '已取消异常信息导出，' + err.data ? err.data : err.message,
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          loading.close()
        }
      })
    },
    destroy () {
      this.importDialog = false
    },
    // 选择数据
    selectGoods (selection) {
    },
    // 日期变化时触发校验
    handleDateChange () {
      // 触发结束日期的重新校验
      if (this.addForm.insuranceDateTo) {
        this.$refs.addForm.validateField('insuranceDateTo')
      }
    },
    // 凭证
    pingzhengFn (row) {
      cVehicleInsuranceNewdetail({ id: row.id }).then(res => {
        if (res.attachments.length == 0) {
          this.$alert('暂无可查看的凭证', '系统提示')
        } else {
          this.pzList = []
          res.attachments.forEach(item => {
            var filename = item.url.split('/').pop()
            this.pzList.push({
              name: filename,
              url: item.fileKeyUrl
            })
          })
          this.pzFlag = true
        }
      })
    },
    fujianClick (row) {
      if (this.isImage(row.name)) {
        this.lookImgFlag = true
        this.imgUrl = row.url
      } else {
        window.open(row.url)
      }
    },
    isImage (filename) {
      const extension = filename.split('.').pop().toLowerCase()
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg']
      return imageExtensions.includes(extension)
    },
    closeViewer () {
      this.dialogImg = false
    },
    // 点击凭证放大
    getSrcList (index, arr) {
      let imgArr = arr.slice(index).concat(arr.slice(0, index))
      let urls = []
      imgArr.forEach(item => {
        urls.push(item.fileKeyUrl)
      })
      return urls
    },
    carChange (e) {
      if (e) {
        let json = this.carList.filter(item => item.vhcNo == e)
        this.$set(this.addForm, 'vehicleId', json[0].id)
        this.$set(this.addForm, 'licensePlateColorName', json[0].noColourName)
        this.$set(this.addForm, 'vehicleTypeName', json[0].vhcTypeName)
      }
    },
    xiaoduiChange (e) {
      if (e) {
        let json = this.XDList.filter(item => item.code == e)
        this.$set(this.addForm, 'teamName', json[0].name)
        this.$set(this.addForm, 'teamId', json[0].id)
        cVIlists({ vhcClassify: 2, trailerFlag: 0, teamOrgId: json[0].id }).then(res => {
          this.loading = false
          this.carList = res
        })
        this.$set(this.addForm, 'vehicleId', null)
        this.$set(this.addForm, 'plateNumber', null)
        this.$set(this.addForm, 'licensePlateColorName', null)
        this.$set(this.addForm, 'vehicleTypeName', null)
      }
    },
    // 添加
    addFn () {
      this.isAdd = true
      this.addFlag = true
      this.imgList = []
      this.$set(this.addForm, 'fillTime', new Date().getTime())
    },
    // 修改
    editFn (row) {
      this.addForm = { ...row }

      this.addForm.deleteAttachmentIds = []
      this.imgList = []
      cVIlists({ vhcClassify: 2, trailerFlag: 0, teamOrgId: row.teamOrgId }).then(res => {
        this.loading = false
        this.carList = res
      })
      cVehicleInsuranceNewdetail({ id: row.id }).then(res => {
        this.isAdd = false
        this.addFlag = true
        res.attachments.forEach(item => {
          this.imgList.push({ status: 'ready', url: item.fileKeyUrl, id: item.id })
        })
      })
    },
    saveFn () {
      // if (this.imgList.length == 0) {
      //   this.$alert('请上传凭证', '系统提示')
      //   return
      // }
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          // 添加日期校验
          if (this.addForm.insuranceDateFrom && this.addForm.insuranceDateTo) {
            if (new Date(this.addForm.insuranceDateTo) <= new Date(this.addForm.insuranceDateFrom)) {
              this.$alert('保单结束日期必须大于开始日期', '系统提示')
              return
            }
          }
          let imgfile = new FormData()
          this.imgList.forEach(item => {
            if (!item.id) {
              imgfile.append('files', item.raw)
            }
          })
          imgfile.set('params', JSON.stringify(this.addForm))
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          saveOrUpdateWithAttachments(imgfile).then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.addFlag = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          return false
        }
      })
    },
    // 删除文件
    remove (file) {
      if (file.id) {
        this.addForm.deleteAttachmentIds.push(file.id)
      }
    },
    // 删除
    delFn () {
      let selectData = this.$refs.table.selection
      this.rowDataList = selectData
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        cVehicleInsuranceNewdeletes({
          ids: selectData.map(item => item.id)
        }).then(res => {
          loading.close()
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 导出
    exportFn () {
      this.searchFrom.businessType = 4
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      exportExcel(
        this.global.driverNameT + '/cVehicleInsuranceNew/export',
        form,
        '车辆保险列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      this.loading = true
      if (this.repairTime) {
        this.$set(this.searchFrom, 'createTimeStart', this.repairTime[0])
        this.$set(this.searchFrom, 'createTimeEnd', this.repairTime[1])
      } else {
        this.$set(this.searchFrom, 'createTimeStart', '')
        this.$set(this.searchFrom, 'createTimeEnd', '')
      }
      if (this.searchFrom.cph) {
        let cphArr = this.searchFrom.cph.split(/\s+/)
          .map(v => v.trim())
          .filter(v => v)
        this.searchFrom.plateNumbers = cphArr.toString()
      } else {
        this.searchFrom.plateNumbers = null
      }
      cVehicleInsuranceNewList(this.searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
        this.loading = false
      })
      cVehicleInsuranceNewListTotal(this.searchFrom).then(res => {
        this.sum = res
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      this.repairTime = []
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.searchFn()
    },
    closeDialog () {
      this.addForm = {
        deleteAttachmentIds: []
      }
      this.imgLis = []
    },
    timeStamp (value) {
      let date = new Date()
      let Y = date.getFullYear()
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
      let D = date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate()
      date = Y + '-' + M + '-' + D
      return date
    },
    cellClassName ({ row, column }) {
      if (column.property === 'insuranceDays' && row.insuranceDays < 30) {
        return 'red-cell-full'
      }
      return ''
    }
  },
  watch: {
    addForm: {
      handler (newName, oldName) {
        if (this.addForm.quantity && this.addForm.amount) {
          this.$set(this.addForm, 'unitPrice', toFixed(this.addForm.amount / this.addForm.quantity, 2))
        }
      },
      immediate: true,
      deep: true
    }
  }

}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}
.inpBox .el-date-editor{
  width:430px!important;
}
/deep/.el-form{
  width: 100%;
}
.jiaoyan /deep/.el-input__inner{
      width: 180px;
}
.imgBox{
  margin:0;
}

.inpBox .dzBox  /deep/.el-input__inner {
    width: 170px;
}
.imgBox{
  /deep/.el-image{
    width: 180px;
    height: 130px;
    margin-right: 20px;
  }
}
.remark  /deep/.el-input .el-input__inner {
    width: 480px;
    height: 80px;
}
.tongjiBox{
   /deep/.el-form-item--mini .el-form-item__content,  /deep/.el-form-item--mini .el-form-item__label{
        line-height: 20px;
  }
}
.formItemBox{
  /deep/.el-form-item{
    width: 24%;
  }
}
/deep/.red-cell-full {
  background-color: #f47474 !important;
  // color: #fff !important;
}
.fujianBox{
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  /deep/.el-button--text{
    text-align: left;
    margin-left: 0;
    margin-bottom: 10px;
  }
}
</style>
